import { Fade, styled } from '@mui/material';

export const DisabledFade = styled(Fade)(() => ({
  '&.disable': {
    display: 'none',
  },
}));
